import { render } from 'react-dom';
import App from './App';
import { GuildOptimizelyProvider } from './components/GuildOptimizelyProvider';

render(
  <GuildOptimizelyProvider>
    <App />
  </GuildOptimizelyProvider>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}
